<div class="buttons-wrapper">
  <div class="header-text">¿Qué quieres hacer hoy?</div>
  <div class="buttons-container">
    <button class="nav-button" [routerLink]="['/menu-contratos']">
      <img src="contrato.webp" alt="Crear Formulario" class="button-icon">
      <div class="button-text">
        <span>Crea</span>
        <span class="bold">Formulario</span>
      </div>
    </button>

    <button class="nav-button" [routerLink]="['/multiple-form']">
      <img src="ciudadano.webp" alt="Generación Masiva" class="button-icon">
      <div class="button-text">
        <span>Generación</span>
        <span class="bold">Masiva</span>
      </div>
    </button>

    <button class="nav-button" [routerLink]="['/form-history']">
      <img src="historial.webp" alt="Historial de Formularios" class="button-icon">
      <div class="button-text">
        <span>Historial de</span>
        <span class="bold">Formularios</span>
      </div>
    </button>
  </div>
</div>
